const copyText = function(text) {
  const input = document.createElement('input')
  input.setAttribute('readonly', 'readonly')
  input.setAttribute('value', text)
  input.style.opacity = 0
  document.body.appendChild(input)
  input.select()
  input.setSelectionRange(0, 9999)
  return new Promise((resolve, reject) => {
    if (document.execCommand('copy')) {
      resolve()
    } else {
      // eslint-disable-next-line prefer-promise-reject-errors
      reject()
    }
    document.body.removeChild(input)
  })
}

export default copyText
